module.exports = __webpack_public_path__ + "img/bank-card-fill.8665d4d4.svg";